import type { CreateRecyclingConsignmentOrderV2SchemaType } from '../common';

type ProductItem =
  CreateRecyclingConsignmentOrderV2SchemaType['productList'][number];

type ProductQrTransferData = Omit<
  ProductItem,
  | 'id'
  | 'aiIdentifyPics'
  | 'authenticationBagId'
  | 'isFakeBag'
  | 'selectedRankDescOptions'
  | 'firstValuationShopRemark'
  | 'guestRemarks'
  | 'firstValuationStock'
  | 'firstValuationStockRemark'
  | 'quoteStaffId'
  | 'quoteTime'
  | 'productPics'
  | 'storeReceiptPics'
  | 'facebookEnabled'
>;

export type ProductQrPayload = {
  type: 'rrs_recycling_consignment_product';
  version: 1;
  data: ProductQrTransferData;
};

export const buildProductQrPayload = (
  product: ProductItem,
): ProductQrPayload => {
  const {
    id,
    aiIdentifyPics,
    authenticationBagId,
    isFakeBag,
    selectedRankDescOptions,
    firstValuationShopRemark,
    guestRemarks,
    firstValuationStock,
    firstValuationStockRemark,
    quoteStaffId,
    quoteTime,
    productPics,
    storeReceiptPics,
    facebookEnabled,
    ...data
  } = product;

  return {
    type: 'rrs_recycling_consignment_product',
    version: 1,
    data,
  };
};

export const serializeProductQrPayload = (product: ProductItem) => {
  return JSON.stringify(buildProductQrPayload(product));
};
